// In the process of moving to permissions by scope.
// See src/constants/permissions.ts for deprecated role-based permissions.

export const scopes = {
  // API-based scopes
  address: [
    "index",
    "create",
    "update",
    "upsert_user_attn",
    "create_reyes_addresses",
  ],
  address_change_request: ["index", "approve_deny"],
  address_favorite_set: ["index", "create", "update", "delete"],
  bid: [
    "index",
    "create",
    "update",
    "delete",
    "accept",
    "decline",
    "award",
    "resend",
  ],
  brand: ["index", "create", "update"],
  //broker_freight: ["update", "delete"],
  budget: ["index", "show"],
  business_unit: ["index"],
  change: ["index"],
  cloudinary_file: ["index", "create", "update", "delete"],
  compliance_override: ["index", "create", "delete"],
  compliance_rules: [
    "index",
    "create",
    "update",
    "approve",
    "deny",
    "resend",
    "deactivate",
  ],
  compliance_states: ["index", "update"],
  cost: ["update", "create", "delete"],
  coupon_type: ["index"],
  historical_item: ["index"],
  historical_order_item: ["index"],
  image: ["create", "delete"],
  imperial: ["initiate_punchout"],
  item: [
    "index",
    "index:archive",
    "create",
    "update",
    "update_supplier",
    "full_item_specs",
  ],
  item_program: ["index", "create", "update", "delete", "clone"],
  item_program_variable_pricing: ["index", "create", "update", "delete"],
  //item_rollup: ["index"],
  //item_sub_type: ["index", "create"],
  item_type: ["index", "create", "update"],
  note: ["index", "create", "update", "delete"],
  order: [
    "index",
    "create",
    "update",
    "delete",
    "update_address",
    "cancel",
    "update_transmitted_inventory",
  ],
  order_calendar_month: ["index", "create", "update"],
  order_window_review: ["index", "items", "orders", "decision", "comments"],
  // order_variant: [
  //   "index",
  //   "cancel",
  //   "track",
  //   "mark_as_transferred",
  //   "update",
  //   "update_address",
  //   "override",
  // ],
  order_set: [
    "index",
    "create",
    "update",
    "delete",
    "approve_deny",
    "submit",
    "cancel",
    "distributor_review",
  ],
  // order_set_variant_summary: ["index"],
  // order_variant_summary: ["index"],
  program: ["index", "create", "update", "delete", "clone", "submit", "cancel"],
  // program_type: ["index"],
  purchase_order: [
    "index",
    "update",
    "create",
    "delete",
    "submit",
    "cancel",
    "complete",
    "accept",
    "decline",
    "receive",
    "notify",
    "update_delivery_date",
    "send_to_flow",
    "convert_to_fulfillment_purchase_orders",
    "add_broker_freight",
    "remove_variant",
    "update_variant",
    "update_beacon_asset_name",
  ],
  purchase_order_variant: ["index", "update", "create", "delete"],
  // report: ["index"],
  request_for_price: [
    "index",
    "create",
    "update",
    "delete",
    "send",
    "complete",
    "cancel",
  ],
  request_for_quote: ["index", "create", "update", "delete", "send", "cancel"],
  // rule: ["index"],
  quote: ["index", "update", "accept", "decline", "complete"],
  sales_group: ["index", "create", "update", "reorder"],
  shipping_parameter: ["index", "create", "update", "update_complete"],
  shipping_parameter_variant: [
    "index",
    "cancel",
    "add_shipping_extras",
    "add_custom_shipping_label",
    "destroy",
  ],
  state: ["index"],
  standard_spec: ["index"],
  supplier: ["index", "create", "update"],
  supplier_report: ["index"],
  territory: ["index", "create", "update"],
  triggered_rule: ["index", "approve_deny"],
  user: ["handle_merge_accounts", "index", "create", "update", "distributor"],
  variable_pricing: ["index", "export", "import"],
  variant_allocation: ["index"],
  variant_option: ["index", "create", "update", "delete"],
  // UI only scopes
  admin: ["view"],
  profile: ["view"],
  distributor: [
    "admin",
    "admin:user:lookup",
    "admin:user:create",
    "admin:user:update",
    "admin:user:delete",
    "admin:organization_user:create",
    "admin:organization_user:update",
    "admin:organization_user:delete",
    "admin:organization_user:branches:update",
    "orders", // Have access to view distributor orders
    "orders:on_demand",
    "orders:inventory",
    "admin:organization_user:checkout_methods:update",
  ],
  distributor_addresses: ["update_country", "email:manage"],
  anaplan_troubleshooting: ["view"],
  sku_migration: ["view", "view_history"],
  planning_tool: ["view", "anaplan:activate", "reports"],
} as const;

export type TScopes = typeof scopes;
export type TScope = {
  [K in keyof TScopes]: `${K}:${TScopes[K][number]}`;
}[keyof TScopes];

// Type checks
const _a: TScope = "address:index";
// @ts-expect-error: address:delete is not a valid scope
const _b: TScope = "address:delete";
// @ts-expect-error: something:index is not a valid scope
const _c: TScope = "something:index";
